import { Wizard } from "react-use-wizard";
import Content from "../Content";
import Footer from "../Footer";
import ImageWithCaption from "../ImageWithCaption";
import CoinbaseCreateImg from "../assets/Coinbase/Extension/Frame02.png";
import CoinbaseUserName from "../assets/Coinbase/Extension/Frame03.png";
import CoinbaseRecovery from "../assets/Coinbase/Extension/Frame04.png";
import CoinbaseRecoverySubmit from "../assets/Coinbase/Extension/Frame05.png";
import CoinbasePassword from "../assets/Coinbase/Extension/Frame06.png";
import CoinbaseSuccess from "../assets/Coinbase/Extension/Frame07.png";

import ExtensionCard from "../ExtensionCard";
import { StepProps } from "../Metamask/MetamaskCreate";

const CoinbaseCreate: React.FC<StepProps> = ({ setFlowState, prevState }) => {
  return (
    <Wizard
      footer={
        <Footer
          setFlowState={setFlowState}
          prevState={prevState}
          currentState="coinbaseCreate"
        />
      }>
      <Content title="Download the Coinbase extension on Google Chrome, and open it.">
        <ExtensionCard wallet="cb" />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Select </span>
            <span className="text-coinage-blue">Create new Wallet.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbaseCreateImg}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Enter a username and select </span>
            <span className="text-coinage-blue">Submit.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbaseUserName}
          caption="Image: Coinbase"
          altText="Adding coinbase username image"
        />
      </Content>
      <Content
        title={<>Coinbase will generate a secret, 12-word recovery phrase.</>}
        description={
          <>
            <span className="text-coinage-orange font-bold">WAIT:</span> Write
            this down somewhere safe. You will not be able to access your wallet
            without it, and it cannot be recovered. <br />
            <br /> Check the box confirming you understand that if you lose your
            recovery phrase, you’ll lose anything stored in your wallet. Select{" "}
            <span className="text-coinage-blue font-bold w-full">
              Continue.
            </span>
          </>
        }>
        <ImageWithCaption
          src={CoinbaseRecovery}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title="Confirm that you’ve saved your recovery phrase."
        description={
          <>
            Select the the first and last words from your recovery phrase.
            Select{" "}
            <span className="text-coinage-blue font-bold w-full">Submit.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbaseRecoverySubmit}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title="Create a password."
        description={
          <>
            Agree to the terms and privacy policy, and select{" "}
            <span className="text-coinage-blue font-bold w-full">Submit.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbasePassword}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        showSuccessIcon
        title="Congratulations!"
        description="You made your first wallet!">
        <ImageWithCaption
          src={CoinbaseSuccess}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
    </Wizard>
  );
};

export default CoinbaseCreate;
